import { Box, Typography, Container } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const steps = [
  "Requirement Analysis",
  "Design & Engineering",
  "Fabrication",
  "Quality Control",
  "Testing",
  "Delivery & Installation",
];

export default function ProcessFlow() {
  return (
    <Box sx={{ py: 10, background: "#fafafa" }}>
      <Container maxWidth="lg">
        {/* Section Heading */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{ textAlign: "center", mb: 6, color: "#1a237e" }}
        >
          Our Work Process
        </Typography>

        {/* FLEX WRAPPER */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 3,
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 45%", md: "1 1 30%" },
                p: 4,
                textAlign: "center",
                background: "#fff",
                borderRadius: 3,
                boxShadow: "0 8px 28px rgba(0,0,0,0.08)",
                transition: "0.3s ease",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
                },
              }}
            >
              {/* Step Number Badge */}
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "#1a237e",
                  color: "#fff",
                  fontSize: 20,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 2,
                }}
              >
                {index + 1}
              </Box>

              {/* Icon */}
              <DoneAllIcon sx={{ fontSize: 48, color: "#d50000", mb: 1 }} />

              {/* Step Title */}
              <Typography fontWeight={700} sx={{ fontSize: 18 }}>
                {step}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
